module.exports = __webpack_public_path__ + "static/media/logoorange.20e1b324.png";